import { useCallback, useEffect, useState } from "react";
import cuentasPorCobrarService from "../../../../services/cuentasPorCobrarService";

export default function useCuentasPorCobrar() {
  const [cuentas, setCuentas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [lastUpdated, setLastUpdated] = useState(null);

  const fetchCuentas = useCallback(async () => {
    setLoading(true);
    try {
      const data = await cuentasPorCobrarService.listar();
      setCuentas(Array.isArray(data) ? data : []);
      setError(null);
      setLastUpdated(new Date());
    } catch (err) {
      console.error(err);
      setError(err.message || "No se pudieron cargar las cuentas por cobrar.");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { fetchCuentas(); }, [fetchCuentas]);

  return { cuentas, loading, error, lastUpdated, reload: fetchCuentas };
}
